<template>
  <div class="page-box">
    <krpanoView @krpanoReady="panoReady"></krpanoView>
 
    <menuArea :krpano="krpano" @openCX="openCx" :uiToggleVar="uiToggleVar" :sceneName="sceneName"></menuArea>

 
    <bottomOption :krpano="krpano" @candleClick="candleClick" @uiToggle="uiToggle"></bottomOption>
    <imgSwiper class="swiper-box" v-if="imgHotspotShow" @closeSwiper="closeSwiper" :baseFile="baseFile"
      :imgNowIndex="imgNowIndex" :imgTotal="imgTotal" :baseUrl="baseUrl"></imgSwiper>
    <textHotpot :textIndex="textIndex" class="hotspot-text-box" v-if="textHotpotShow" @closeHot="closeTextHot">
    </textHotpot>
    <panoMap :uiToggleVar="uiToggleVar" :krpano="krpano" :sceneName="sceneName" @showMap="showMap" @closeEnter="closeEnterMap"></panoMap>
    <videoHotspot v-if="videoShow" @closeVideo="closeVideo" :guid="guid"></videoHotspot>
    <liveHotspot v-if="LiveShow" @closeLive="closeLive" :zhiboId="zhiboId"></liveHotspot>
    <audioHotspot v-if="audioShow" @closeAudio="closeAudio" :audioSrc="audioSrc"></audioHotspot>
    <leaveMessage></leaveMessage>
    <messageScroll />
    <!-- <innvateBoutique ref="innvateBoutique"></innvateBoutique> -->
    <!-- <div class="guide-box" v-if="guideShow" @click="jump">
      <div class="jump-title">跳过</div>
    </div> -->
 
    <actualTimePopularity />
    <guidePage v-if="guideShow" @iknow="handleIknow" />
    <enter-map @openCX="openCx" v-if="enterShow" :krpano="krpano" :sceneName="sceneName" @closeEnter="closeEnterMap"></enter-map>
  </div>
</template>

<script>
import krpanoView from "@/components/krpanoView";
import imgSwiper from "@/components/imgSwiper";
 
import bottomOption from "@/components/bottomOption";
import menuArea from "@/components/menu";
import textHotpot from "@/components/textHotspot";
import videoHotspot from "@/components/videoHotspot";
import audioHotspot from "@/components/audioHotspot";
import liveHotspot from "@/components/liveHotspot";
import panoMap from "@/components/panoMap";
 
import leaveMessage from "@/components/leaveMessage";
import guidePage from "@/components/guidePage";
 
import actualTimePopularity from "@/components/actualTimePopularity/index";
import messageScroll from '@/components/messageScroll';
import enterMap from '@/components/enter_map';
import innvateBoutique from "@/components/innvateBoutique"
import {
  open_music,
  close_music,
  play_music,
  init_music
} from '@/utils/audio'
 
export default {
  components: {
    imgSwiper,
    krpanoView,
 
    bottomOption,
    menuArea,
    textHotpot,
    panoMap,
    videoHotspot,
    leaveMessage,
    audioHotspot,
    guidePage,
 
    actualTimePopularity,
    messageScroll,
    liveHotspot,
    enterMap,
    innvateBoutique
  },
  data() {
    return {
      viewModel: 1,
      krpano: "",
      imgHotspotShow: false,
      textHotpotShow: false,
      mapShow: false,
      textIndex: "",
      flowerShow: false,
      imgNowIndex: "",
      imgTotal: "",
      baseUrl: "",
      baseFile: "",
      uiToggleVar: true,
      videoShow: false,
      guid: "",
      sceneName: "",
      guideShow: true,
      audioShow: false,
      audioSrc: "",
      LiveShow: false,
      zhiboId: "",
      enterShow: true
    };
  },
  watch: {
    sceneName(val) {

    },
  },
  methods: {
    closeEnterMap() {
      this.enterShow = false
    },
    panoReady(pano) {
      this.krpano = pano;
    },
    showImgHotspot(baseFile, baseUrl, nowIndex, total) {
      this.imgHotspotShow = true;
      this.baseFile = baseFile;
      this.baseUrl = baseUrl;
      this.imgNowIndex = nowIndex;
      this.imgTotal = total;
    },
    closeSwiper() {
      this.imgHotspotShow = false;
      this.baseFile = "";
      this.baseUrl = "";
      this.imgNowIndex = "";
      this.imgTotal = "";
    },
    showTextHotspot(textIndex) {
      this.textHotpotShow = true;
      this.textIndex = textIndex;
    },
    closeTextHot() {
      this.textHotpotShow = false;
      this.textIndex = "";
    },
    mapToggle(showOrHide) {
      this.mapShow = showOrHide;
    },
    toggleFlower(flowerShow) {
      this.flowerShow = flowerShow;
    },
    candleClick() {
      this.flowerShow = true;
    },
    uiToggle(uiToggle) {
      this.uiToggleVar = uiToggle;
    },
    mediaOpenAudio() {
      close_music()
    },
    mediaCloseAudio() {
      open_music()
    },
    closeVideo() {
      this.videoShow = false;
      this.mediaCloseAudio();
    },
    showVideo(guid) {
      this.guid = guid;
      this.videoShow = true;
      this.mediaOpenAudio()
    },
    closeLive() {
      this.LiveShow = false;
      this.mediaCloseAudio();
    },
    showLive(zhiboId) {
      this.zhiboId = zhiboId;
      this.LiveShow = true;
      this.mediaOpenAudio()
    },
    openAudio(src) {
      this.audioSrc = src;
      this.audioShow = true;
      this.mediaOpenAudio()
    },
    closeAudio() {
      this.audioShow = false;
      this.mediaCloseAudio();
    },
    locationStart(audioSr,bgmusicSrc) {
      this.sceneName = this.krpano.get("xml.scene");
      var nowSceneName = this.sceneName.split("_");
 
      play_music(audioSr,bgmusicSrc)
    },
    
    // 引导页面 - 我知道了
    handleIknow() {
      this.guideShow = false;
      init_music()
    },
    closeEnterMap() {
      this.enterShow = false
    },
    showMap() {
      this.enterShow = true
    },
    openCx(){
      if (this.guideShow) {
        this.handleIknow();
      }
   
      this.$refs.innvateBoutique.handleshowCX();
      window.goldlog.record("/spec.1.1", "", "snsScene=创新100+&product=pcweb&pagename=云上2024年中国品牌博览会", "")
    }
  },
  mounted() {
    window.showTextHotspot = this.showTextHotspot;
    window.popImg = this.showImgHotspot;
    window.popVideo = this.showVideo;
    window.popAudio = this.openAudio;
    window.popLive = this.showLive;
    window.locationStart = this.locationStart;
    window.openFlower = this.toggleFlower;
  },
 

};
</script>

<style lang="scss" scoped>
.page-box {
  width: 100%;
  height: 100%;
  position: relative;

  .swiper-box {
    position: absolute;
    top: 0;
  }

  @mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .top-nav {
    width: 100%;
    height: 1.42rem;
    background-image: url("../../../assets/img/top-nav.png");
    @include background-com();
    position: absolute;
    top: 0;
    left: 0;
  }

  .model-change {
    width: 1.2rem;
    height: 0.48rem;
    text-align: center;
    line-height: 0.48rem;
    color: #ffffff;
    font-size: 0.16rem;
    border-radius: 0.24rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    background-color: #8f0000;
    cursor: pointer;
  }

  .guide-box {
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/img/guide.png");
    @include background-com();
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000000;

    .jump-title {
      color: #ffffff;
      font-size: 0.3rem;
      position: absolute;
      padding-bottom: 0.1rem;
      border-bottom: 1px solid #ffffff;
      right: 0.5rem;
      bottom: 0.5rem;
      cursor: pointer;
    }
  }
}
</style>